import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Stepper, Step, StepLabel, Box, Button, IconButton, Modal, Divider } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import InfoIcon from "@mui/icons-material/Info";
import record_icon from '../../../../Assets/img/icons/Recording-symbol.svg';
import { useReactMediaRecorder } from "react-media-recorder-2";
import voice_indicator from "../../../../Assets/img/icons/voice-indicator.svg"
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

import replay from "../../../../Assets/img/icons/replay.svg"
import Video_Start from "../../../../Assets/img/icons/Video_Start.svg"
import Video_End from "../../../../Assets/img/icons/stop.svg"
import Video_pause from "../../../../Assets/img/icons/Video_pause.svg"
import Video_play from "../../../../Assets/img/icons/Video_replay.svg"
import { ReactComponent as TickIcon } from "../../../../Assets/img/icons/tick-shape.svg";
import { ReactComponent as AiLogo } from "../../../../Assets/img/icons/ai-rewrite-logo.svg";

// import AnimateDataGIF from "../../../../Assets/img/audio-wave.gif"
import { LinearProgress, Typography, } from '@mui/material';
import PropTypes from 'prop-types';
import { useProfileContext } from '../../../ProfileDetailContext'
import useApi from '../../../Utilities/useAPI';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useQuantityContext } from '../../../QuantityContext';
import axios from 'axios';
import { useSelector } from 'react-redux';

const VideoResume = () => {
    // const { ExperienceList, ProfessionalDetails, projectList, awardsList, educationList, certificateList, updateResume } = useProfileContext();

    const ProfessionalData = useSelector((state) => state?.ProfileArray?.professionaProfile);
    const ProfessionalEducation = useSelector((state) => state?.ProfileArray?.educationData?.data) || [];
    const ProfessionalExperience = useSelector((state) => state?.ProfileArray?.experienceData?.data) || [];
    const ProfessionalProject = useSelector((state) => state?.ProfileArray?.projectData?.data) || [];
    const ProfessionalAwards = useSelector((state) => state?.ProfileArray?.awardsData?.data) || [];
    const ProfessionalCertificate = useSelector((state) => state?.ProfileArray?.certificateData?.data) || [];
    const Resumedata = useSelector((state) => state?.ProfileArray?.ResumeData?.data) || [];
    const ProfessonalSoftSkills = useSelector((state) => state?.ProfileArray?.professionalSkills?.data?.soft_skills) || [];
    const ProfessonalToolsSkills = useSelector((state) => state?.ProfileArray?.professionalSkills?.data?.professional_tools) || [];
    const ProfessonalSkills = useSelector((state) => state?.ProfileArray?.professionalSkills?.data?.professional_skills) || [];

    const { openSnackbar } = useQuantityContext();
    // const [selectedSkills, setSelectedSkills] = useState(ProfessionalDetails.skills || []);
    const accessToken = localStorage.getItem("objectId");

    const { callApiFunction } = useApi();
    const headers = {
        Authorization: `Bearer ${accessToken}`,
        "x-api-key": process.env.REACT_APP_API_KEY,
        "Content-type": "multipart/form-data"
    }

    const {
        status,
        startRecording,
        stopRecording,
        pauseRecording,
        resumeRecording,
        mediaBlobUrl,
        previewStream
    } = useReactMediaRecorder({ video: true });
    const navigate = useNavigate();

    const sectionTimes = {
        'About Me': 20000,
        'Education': 15000,
        'Work Experience': 35000,
        'Skills': 15000,
        'Achievements': 10000,
        'Certifications': 10000,
        'Closing Statement': 15000
    };

    const steps = Object.keys(sectionTimes);
    const [activeStep, setActiveStep] = useState(0);
    const [openBigScreen, setopenBigScreen] = useState(false);
    const [recorderStatus, setRecorderStatus] = useState(false);

    const [progress, setProgress] = useState(0);
    const [particularProgress, setParticularProgress] = useState(0);

    const [stream, setStream] = useState(null);
    const smallScreenVideoRef = useRef(null);
    const bigScreenVideoRef = useRef(null);

    const MAX_RECORDING_TIME = 120; // 2 minutes limit (120 seconds)

    // Function to start camera preview once (prevents blinking/reinitializing)
    const getCameraStream = useCallback(async () => {
        try {
            // Check if permission for camera and microphone is already granted
            const cameraPermission = await navigator.permissions.query({ name: 'camera' });
            const microphonePermission = await navigator.permissions.query({ name: 'microphone' });

            if (cameraPermission.state === 'denied' || microphonePermission.state === 'denied') {
                console.warn("Camera or microphone access denied. Please enable permissions in your browser settings.");
                openSnackbar("Please enable camera and microphone permissions in your browser settings.", "info");
                return;
            }

            // If permissions are not explicitly denied, request them
            const mediaStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
            setStream(mediaStream);
        } catch (err) {
            console.error("Failed to access camera or microphone: ", err);
            openSnackbar("Could not access camera or microphone. Please check permissions.", "error");
        }
    }, [openSnackbar]);

    // Assign video stream to the appropriate video element
    const assignStreamToVideo = (videoRef) => {
        if (videoRef && videoRef.current && stream) {
            videoRef.current.srcObject = stream;
        }
    };

    // Update the video element whenever openBigScreen changes
    useEffect(() => {
        if (openBigScreen) {
            assignStreamToVideo(bigScreenVideoRef);
        } else {
            assignStreamToVideo(smallScreenVideoRef);
        }
    }, [openBigScreen, stream]);

    // Start preview when component mounts
    useEffect(() => {
        console.log('getCameraStream useEffect called!!!')
        getCameraStream();

        // Clean up the camera stream on component unmount
        return () => {
            if (stream) {
                stream.getTracks().forEach(track => track.stop());
            }
        };
    }, [getCameraStream]);

    useEffect(() => {
        const calculateOverallProgress = () => {
            const overallProgress = ((activeStep + 1) / steps.length) * 100;
            setProgress(overallProgress);
        };

        calculateOverallProgress();

    }, [activeStep]);

    // useEffect(() => {
    //     let interval;
    //     if (particularProgress < 100) {
    //         interval = setInterval(() => {
    //             setParticularProgress(prevProgress => {
    //                 if (prevProgress < 100) {
    //                     return 100; // Incrementing to reach 100% in 30 seconds
    //                 } else {
    //                     clearInterval(interval);
    //                     return 100;
    //                 }
    //             });
    //         }, 10000);
    //     }
    //     return () => clearInterval(interval);
    // }, [particularProgress]);

    // States and Functions for Action Buttons
    // States and functions for section-wise timer
    const [remainingTime, setRemainingTime] = useState(sectionTimes[steps[0]]); // Tracks remaining time for the current section

    const sectionTimerRef = useRef(null); // Ref to manage the section timer

    useEffect(() => {
        const calculateParticularProgress = () => {
            if (status === 'recording') {
                // Calculate the current section's progress
                const totalTimeForSection = sectionTimes[steps[activeStep]]; // Total time allocated for the current section
                const timeElapsed = totalTimeForSection - remainingTime; // Time that has passed in the current section

                // Calculate particular progress percentage
                const currentProgress = (timeElapsed / totalTimeForSection) * 100; // Current section progress
                setParticularProgress(currentProgress);
            }
        }

        calculateParticularProgress();
    }, [remainingTime]);

    // Stop the section timer
    const stopSectionTimer = useCallback(() => {
        clearInterval(sectionTimerRef.current);
        sectionTimerRef.current = null;
    }, []);

    // Start the section timer
    const startSectionTimer = useCallback(() => {
        console.log("Entered startSectionTimer callback");
        if (sectionTimerRef.current || activeStep >= steps.length - 1) {
            console.log("IF IS TRUE, EXITING CALLBACK FUNCTION...");
            console.log("sectionTimerRef:", sectionTimerRef, "\nactiveStep:", activeStep, "\nstatus:", status);
            return;
        }
        console.log("EXECUTING CALLBACK FUNCTION...");

        sectionTimerRef.current = setInterval(() => {
            setRemainingTime(prevTime => {
                if (prevTime <= 1000) {
                    setActiveStep(prevStep => {
                        if (prevStep < steps.length - 1) {
                            console.log('Automatic transition to next step:', prevStep + 1);
                            setParticularProgress(0);
                            return prevStep + 1; // Move to the next section automatically
                        } else {
                            stopSectionTimer(); // Stop timer when reaching the last section
                            return prevStep; // Ensure we stay on the last step
                        }
                    });
                    return sectionTimes[steps[activeStep + 1]] || 0; // Reset time for the next section or 0 if the last
                }
                return prevTime - 1000; // Decrease time by 1 second
            });
        }, 1000);
    }, [activeStep, steps, stopSectionTimer]);

    useEffect(() => {
        return () => {
            stopSectionTimer(); // Clear timer on unmount
        };
    }, [stopSectionTimer]);

    const handleVdoPause = () => {
        stopTimer();
        stopSectionTimer();
        pauseRecording();
    }

    const handleVdoPlay = () => {
        resumeRecording();
        startTimer();
        startSectionTimer();
    }

    const handleNext = useCallback(() => {
        stopSectionTimer(); // Stop timer for the current step
        if (activeStep < steps.length - 1) {
            console.log('activeStep:', activeStep, ' steps.length:', steps.length);
            setActiveStep(prevStep => prevStep + 1);
            setRemainingTime(sectionTimes[steps[activeStep + 1]]); // Reset time for the next section
            setParticularProgress(0);
            if (status === 'recording') {
                startSectionTimer(); // Restart the timer for the new section
            }
        } else {
            // If on the last step, stop progression
            stopSectionTimer(); // Ensure timer is stopped
            setRemainingTime(0); // Set time to zero for the last section
        }
    }, [activeStep, steps, stopSectionTimer, startSectionTimer]);


    const handlePrev = () => {
        if (activeStep > 0) {
            stopSectionTimer();
            setActiveStep(prevStep => prevStep - 1);
            setRemainingTime(sectionTimes[steps[activeStep - 1]]); // Reset time for the previous section
            setParticularProgress(0);
            if (status === 'recording') {
                startSectionTimer(); // Restart the timer for the previous section, if recording
            }
        }
    };

    const timerSec12 = useRef(0); // Initialize useRef with 0, not { current: 0 }
    const intervalId = useRef(null, []);

    const startTimer = () => {
        intervalId.current = setInterval(() => {
            timerSec12.current++;
            updateTimerDisplay(); // Update timer display directly

            // Stop and save video automatically after 2 minutes
            if (timerSec12.current >= MAX_RECORDING_TIME) {
                handleVdoEnd();
                setTimeUpModalOpen(true);
            }
        }, 1000)
    };

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
        const secs = (seconds % 60).toString().padStart(2, '0');
        return `${mins}:${secs}`;
    };

    const updateTimerDisplay = () => {
        const timerElement = document.getElementById('timerDisplay');
        if (timerElement) {
            const formattedTime = formatTime(timerSec12.current);
            timerElement.textContent = `REC: ${formattedTime}`;
        }
    };

    const stopTimer = () => {
        clearInterval(intervalId.current);
        intervalId.current = null;
        updateTimerDisplay();
    };

    const handleVdoStart = () => {
        startRecording();
        startTimer();
        setRemainingTime(sectionTimes[steps[0]]); // Reset time for the current section
        startSectionTimer();
    }

    const handleVdoEnd = () => {
        // setRecorderStatus("end");
        timerSec12.current = 0;
        stopTimer();
        stopSectionTimer();
        stopRecording();
    }

    const handleVdoRestart = () => {
        // setRecorderStatus("end");
        timerSec12.current = 0;
        stopTimer();
        stopSectionTimer();
        stopRecording();
        setActiveStep(0);
        setRemainingTime(sectionTimes[steps[0]]);
        setParticularProgress(0);
    }

    useEffect(() => {
        return () => {
            clearInterval(intervalId.current);
        };
    }, []);

    // const handleSave = () => {
    //     if (mediaBlobUrl) {
    //         const fileObject = {
    //             id: 0, // Initial id as 0, to be updated later
    //             name: 'Video Resume.mp4',
    //             type: 'video/mp4',
    //             data: mediaBlobUrl,
    //             date: new Date().toLocaleDateString('en-GB'),
    //         };

    //         updateResume('videos', fileObject, 'add');
    //         navigate('/myprofile');
    //     } else {
    //         alert('Video not ready to be saved!');
    //     }
    // }

    // Save video to the user's local machine
    const saveVideoToLocal = async () => {
        stopRecording();
        if (mediaBlobUrl) {
            // Fetch the blob data
            const blobResponse = await fetch(mediaBlobUrl);
            const blob = await blobResponse.blob();

            // Convert blob to File
            const file = new File([blob], "Video_Resume.mp4", { type: blob.type });
            const formData = new FormData();
            formData.append('file', file);
            formData.append('section_slug', 'video_resume');
            try {
                openSnackbar("Saving your Video Resume...", "info", 10000);
                const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/upload_document`, formData, {
                    headers: headers
                })
                if (response.data?.statusCode === 200) {
                    // openSnackbar("Video Resume Downloaded!", "success", 4000);
                    // const a = document.createElement('a');
                    // a.href = mediaBlobUrl;
                    // a.download = 'Video Resume.mp4';
                    // document.body.appendChild(a);
                    // a.click();
                    // document.body.removeChild(a);
                    openSnackbar("Video Saved successfully!", "success",);
                }
            } catch (error) {
                console.log("Error Saving Video Resume:", error);
                openSnackbar("Failed to Save Video Resume. Try again Later.", "error");
            }
        } else {
            handleInfo("Please stop the recording before saving.")
        }
    };

    // Save button handler (manual save)
    const handleSave = () => {
        saveVideoToLocal();
    };

    // States and functions for instructions dialog
    const [isInstructionsOpen, setIsInstructionsOpen] = useState(true);

    const handleInstructionModalClose = () => {
        setIsInstructionsOpen(false);
    }

    // States and functions for Saving after 2 minutes
    const [timeUpModalOpen, setTimeUpModalOpen] = useState(false);

    const handleTimeUpModalClose = () => {
        setTimeUpModalOpen(false);
    }

    // Success and Failure Toasts
    const handleSuccess = (item = '', op = 'Save') => {
        let successMessage;
        if (op === 'Delete')
            successMessage = item && item !== '' ? item : 'Deleted Successfully!';
        else if (op === 'Save')
            successMessage = item && item !== '' ? item : 'Saved Successfully!';
        openSnackbar(successMessage, "success");
    };

    const handleFailure = (item = '', op = 'Save') => {
        let failureMessage;
        if (op === 'Delete')
            failureMessage = item && item !== '' ? item : 'Failed to Delete. Try Again.';
        else if (op === 'Save')
            failureMessage = item && item !== '' ? item : 'Failed to Save. Try Again.';
        openSnackbar(failureMessage, "error");
    };

    const handleInfo = (item = '') => {
        openSnackbar(item, "info");
    }

    // States variables to hold already-stored data 

    const [aboutMe, setAboutMe] = useState('');
    const [educationContent, setEducationContent] = useState('');
    const [experienceContent, setExperienceContent] = useState('');
    const [skillsContent, setSkillsContent] = useState('');
    const [awardsContent, setAwardsContent] = useState('');
    const [certificatesContent, setCertificatesContent] = useState('');
    const declarationString = 'I hereby declare that the information provided above is true and accurate to the best of my knowledge. I am committed to contributing my skills and experience to the success of your organization.';

    // GPT Rewrite API
    const handleRewriteContent = async () => {
        openSnackbar("Rewriting your content...", "info");
        const prompt = {
            aboutMe: ProfessionalData?.about_me,
            education: ProfessionalEducation?.map((education) => ({
                degree: education?.degree,
                field: education?.field_of_study,
                institution: education?.institute_name,
                yearCompleted: education?.is_pursuing === true ? 'Present' : education?.end_year,
                details: education?.desc
            })),
            experience: ProfessionalExperience?.map((experience) => ({
                company: experience?.company_name,
                location: experience?.location,
                role: experience?.role_title,
                startDate: experience?.start_month + ' ' + experience?.start_year,
                endDate: experience?.end_month + ' ' + experience?.is_currently_working === true ? 'Present' : experience?.end_year,
                details: experience?.details
            })),
            skills: {
                softSkills: ProfessonalSoftSkills?.skills,
                professionalSkills: ProfessonalSkills?.skills,
                tools: ProfessonalToolsSkills?.skills
            },
            awards: ProfessionalAwards?.map((award) => ({
                title: award?.award_title,
                issueDate: award?.issue_month + ' ' + award?.issue_year,
                associatedWith: award?.associated_with,
                issuer: award?.issuer,
                description: award?.description
            })),
            certificates: ProfessionalCertificate?.map((certificate) => ({
                title: certificate?.course_name,
                organization: certificate?.organisation_name,
                date: certificate?.issue_date + ' ' + certificate?.year
            })),
            declaration: declarationString
        }

        try {
            const response = await callApiFunction('rewriteWithAI', { prompt: prompt });
            if (response.status === 'SUCCESS') {
                const responseData = response.data;
                setAboutMe(responseData.aboutMe);
                setEducationContent(responseData.education);
                setExperienceContent(responseData.experience);
                setSkillsContent(responseData?.skills);
                setAwardsContent(responseData?.awards);
                setCertificatesContent(responseData.certificates);
                openSnackbar("Content Successfully rewritten with AI!", "success")
            }
        } catch (error) {
            console.error('Failed to Rewrite content with AI', error);
            openSnackbar("Could Not Rewrite your content. Try Again Later.", "error")
        }
    }

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <>
                        <h2 className="headingforContent video-resume-heading">About Me</h2>
                        <div>
                            {aboutMe ? aboutMe : ProfessionalData?.about_me}
                        </div>
                    </>
                );
            case 1:
                return (<>
                    <h2 className="headingforContent video-resume-heading">Education</h2>
                    <div className="education-list">
                        {educationContent ? educationContent :
                            ProfessionalEducation?.map((education, index) => (
                                <div className="education-item" key={index}>
                                    <div className="d-flex">
                                        <div className="ms-3 d-flex flex-column text-left">
                                            <div className="d-flex justify-content-between">
                                                {education?.educational_level === 'SSLC' || education?.educational_level === 'HSC' ?
                                                    <div className="university-name">{education?.institute_name}</div>
                                                    :
                                                    <div className="university-name">{education?.board}</div>
                                                }
                                            </div>
                                            <div className="bordered-study-year design-lighter-text mb-2">
                                                {education?.start_year} - {education?.is_pursuing === true ? 'Present' : education?.end_year}
                                            </div>
                                            {education?.educational_level === 'SSLC' || education?.educational_level === 'HSC' ?
                                                <>
                                                    <div className="margin-bottom-8px">{education?.educational_level}</div>
                                                    {education?.educational_level === 'HSC' && <div className="margin-bottom-8px">{education?.field_of_study}</div>}
                                                </>
                                                : <>
                                                    <div className="margin-bottom-8px">{education?.degree}</div>
                                                    <div className="margin-bottom-8px">{education?.field_of_study}</div>
                                                </>
                                            }
                                            <div className="margin-bottom-8px">Details:</div>
                                            <div className="design-lighter-text margin-bottom-8px">{education?.desc}</div>
                                        </div>
                                    </div>
                                    <div className="divider" />
                                </div>
                            ))}
                    </div>
                </>
                );
            case 2:
                return (
                    <>
                        <h2 className="headingforContent video-resume-heading">Experience</h2>
                        <div>
                            {experienceContent ? experienceContent :
                                ProfessionalExperience?.map((experience, index) => (
                                    <div className="education-item" key={index}>
                                        <div className="d-flex">
                                            <div className="ms-3 d-flex flex-column text-left">
                                                <div className="d-flex justify-content-between">
                                                    <div className="university-name margin-bottom-8px">{experience?.companyName}</div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-start design-lighter-text mb-2">
                                                    <div>{experience?.location}</div>
                                                    <span className="dot-locationtype">.</span>
                                                    <div>{experience?.location_type}</div>
                                                </div>
                                                <div className="bordered-study-year design-lighter-text mb-2">
                                                    {experience?.start_month.substring(0, 3).toUpperCase()} {experience?.start_year} - {experience?.is_currently_working === "Present" ? "Present" : `${experience?.end_month.substring(0, 3).toUpperCase()} ${experience?.end_year}`}
                                                </div>
                                                <div className="margin-bottom-8px role-title-bold">{experience?.role_title}</div>
                                                <div className="margin-bottom-8px">{experience?.employee_type}</div>
                                                <div className="design-lighter-text margin-bottom-8px">{experience?.responsibility}</div>
                                            </div>
                                        </div>
                                        <div className="divider" />
                                    </div>
                                ))}
                        </div>
                    </>
                )
            case 3:
                return (<>
                    <h2 className="headingforContent video-resume-heading">Skills</h2>
                    {skillsContent ? skillsContent :
                        <>
                            <div className="mb-2">
                                <h5 className='mb-2'>Soft Skills:</h5>
                                <div className="skills-list-professional">
                                    {ProfessonalSoftSkills?.skills?.map((skill, index) => (
                                        <div key={index}>{skill}, </div>
                                    ))}
                                </div>
                            </div>

                            <div className="mb-2">
                                <h5 className='mb-2'>Professional Skills:</h5>
                                <div className="skills-list-professional">
                                    {ProfessonalSkills?.skills?.map((skill, index) => (
                                        <div key={index}>{skill},{" "}</div>
                                    ))}
                                </div>
                            </div>

                            <div className="mb-2">
                                <h5 className='mb-2'>Tools:</h5>
                                <div className="skills-list-professional">
                                    {ProfessonalToolsSkills?.skills?.map((skill, index) => (
                                        <div key={index}>{skill}, </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    }
                </>)
            case 4:
                return (<>
                    <h2 className="headingforContent video-resume-heading">Honors and Awards</h2>
                    <div className="ms-2 education-list">
                        {awardsContent ? awardsContent :
                            ProfessionalAwards?.map((award, index) => (
                                <div key={index} className="education-item text-left">
                                    <div className="project-profile">Title:</div>
                                    <div className="design-lighter-textNew">{award?.award_title}</div>
                                    {award?.issue_month || award?.issue_year &&
                                        <div>
                                            <div className="project-profile">Issue Date:</div>
                                            <div className="design-lighter-textNew">{award?.issue_month} {award?.issue_year}</div>
                                        </div>
                                    }
                                    {award?.associated_with &&
                                        <div>
                                            <div className="project-profile">Associated With:</div>
                                            <div className="design-lighter-textNew">{award?.associated_with}</div>
                                        </div>
                                    }
                                    {award?.issuer &&
                                        <div>
                                            <div className="project-profile">Issuer:</div>
                                            <div className="design-lighter-textNew">{award?.issuer}</div>
                                        </div>
                                    }
                                    {award?.description?.length !== 0 &&
                                        <div>
                                            <div className="project-profile">Description:</div>
                                            <div className="design-lighter-textNew me-2 line-break">{award?.description} </div>
                                        </div>
                                    }

                                    <div className="divider" />
                                </div>
                            ))}
                    </div>
                </>)
            case 5:
                return (<>
                    <h2 className="headingforContent video-resume-heading">Certificates</h2>
                    <div>
                        {certificatesContent ? certificatesContent :
                            ProfessionalCertificate?.map((certification, index) => (
                                <div className="education-item" key={index}>
                                    <div className="d-flex">
                                        <div className="ms-3 d-flex flex-column text-left">
                                            <div className="d-flex justify-content-between">
                                                <div className="university-name">{certification?.organisation_name}</div>
                                            </div>
                                            <div className="bordered-study-year design-lighter-text">
                                                {certification?.issue_date} - {certification?.year}
                                            </div>
                                            <div className="margin-bottom-8px">{certification?.course_name}</div>
                                            <div className="margin-bottom-8px">Details:</div>
                                            <div className="design-lighter-text margin-bottom-8px">{certification?.description}</div>
                                        </div>
                                    </div>
                                    <div className="divider" />
                                </div>
                            ))}
                    </div>
                </>)
            case 6:
                return (<>{declarationString}</>)
            default:
                return 'Unknown step';
        }
    };

    return (
        <>
            {!openBigScreen &&
                <div className="video-resume-wrapper">
                    <div className="content">
                        <h6 className="text-left fw-bold">Create Your Video Resume
                            <IconButton onClick={() => setIsInstructionsOpen(true)}>
                                <InfoIcon />
                            </IconButton>
                        </h6>
                        <div className="sub-tit-email text-left">
                            Follow the steps below to create a standout video resume that highlights your skills, experiences, and personality.
                        </div>

                        <div className="d-flex align-items-stretch justify-content-center">
                            <div className="Video-Resume-steps-container flex-grow-1 pt-25">
                                <Box sx={{ width: "100%" }} className="stepsflow-container VoiceResume-Steppers">
                                    <Stepper activeStep={activeStep} orientation="vertical" className="custom-stepper-videoResume">
                                        {steps.map((label, index) => (
                                            <Step key={index}>
                                                <StepLabel className="fw-bold">{label}</StepLabel>
                                                {index < steps.length - 1 && <div className="step-line" />}
                                            </Step>
                                        ))}
                                    </Stepper>
                                </Box>
                            </div>
                            <div className="video-reading-part flex-grow-1">
                                <div className="left-right-VideoResume flex-center">
                                    <FaAngleLeft onClick={() => { setopenBigScreen(true); }} color='0044c6' />
                                </div>
                                <div className="d-flex justify-content-between mt-4 mb-1 px-2">
                                    <div className="flex-center">
                                        <img src={record_icon} alt="Recording Symbol" className="max-24px" />
                                        <span className="ms-1 recording-font" id="timerDisplay">REC: 00: 00</span>
                                        {/* <p className="ms-1 recording-font" id="timerDisplay">Status: {status}</p> */}
                                    </div>
                                    <Button
                                        variant='outlined'
                                        sx={{ color: '#0044C6' }}
                                        className='ai-rewrite-button'
                                        onClick={handleRewriteContent}
                                        disabled={status === "recording"}
                                        startIcon={<AiLogo />}>
                                        Rewrite
                                    </Button>
                                </div>

                                <div className="d-flex">
                                    <div className="video-recording-left-part px-2">
                                        <div className="recording-section-LeftPart" style={{ overflow: 'hidden' }}>
                                            {/* <CustomMediaRecorder2 setRecorderStatus={setRecorderStatus} /> */}
                                            <div className="media-recorder-videoResume" >
                                                {stream && (
                                                    <video
                                                        ref={smallScreenVideoRef}
                                                        autoPlay
                                                        muted
                                                    />
                                                )}
                                                {/* {mediaBlobUrl && <video src={mediaBlobUrl} controls autoPlay loop />} */}
                                                <div className="controls-video-resume d-flex justify-content-center align-items-center gap-4">
                                                    {status === "recording" ? (
                                                        <>
                                                            {/* Pause button */}
                                                            <button onClick={handleVdoPause}>
                                                                <img className='Video-Resume-Small-Controls' src={Video_pause} alt="pause_button" />
                                                            </button>
                                                            {/* End recording button */}
                                                            <button onClick={handleVdoEnd}>
                                                                <img className='Video-Resume-Small-Controls' src={Video_End} alt="end_button" />
                                                            </button>
                                                        </>
                                                    ) : status === "paused" ? (
                                                        <>
                                                            {/* Resume button */}
                                                            <button onClick={handleVdoPlay}>
                                                                <img className='Video-Resume-Small-Controls' src={Video_play} alt="resume_button" />
                                                            </button>
                                                            {/* End recording button */}
                                                            <button onClick={handleVdoEnd}>
                                                                <img className='Video-Resume-Small-Controls' src={Video_End} alt="end_button" />
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <>
                                                            {/* Start recording button */}
                                                            <button onClick={handleVdoStart}>
                                                                <img className='Video-Resume-Small-Controls' src={Video_Start} alt="start_button" />
                                                            </button>
                                                        </>
                                                    )}
                                                    {/* {status === "recording" ? (
                                                        <button>
                                                            <img src={AnimateDataGIF} alt="pause_button" />
                                                        </button>
                                                    ) : (
                                                        <button>
                                                            <img src={voice_indicator} alt="voice" />
                                                        </button>
                                                    )} */}
                                                    <button>
                                                        <img src={voice_indicator} alt="voice" />
                                                    </button>
                                                    {(status === 'recording' || status === 'paused') &&
                                                        <button onClick={handleVdoRestart}>
                                                            <img className='Video-Resume-Small-Controls' src={replay} alt="replay_button" />
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className="my-3 video-recording-progress flex-center">
                                            <div className="resume-progrss-subBox">
                                                {/* {mediaBlobUrl && <div>mediaBlobUrl: {mediaBlobUrl} </div>} */}
                                                <span className="d-block ps-4 my-1">Resume Progress</span>
                                                <div className='p-3 flex-center flex-column gap-1'>
                                                    <div>Time left: {Math.floor(remainingTime / 1000)} seconds and Active Step: {activeStep}</div>
                                                    <Box sx={{ width: '90%' }} className="resume-progress-first">
                                                        <LinearProgressWithLabel value={particularProgress} content={"Particular Section"} />
                                                    </Box>
                                                    <Box sx={{ width: '90%' }} className="resume-progress-Overalll">
                                                        <LinearProgressWithLabel value={progress} content={"Overall Section"} />
                                                    </Box>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ms-3 video-recording-left-part">
                                        <div className="content-for-videoRecording p-4">
                                            <div className="content-for-CurrentTitle mb-1">
                                                {getStepContent(activeStep)}

                                                {/* {mediaBlobUrl && (
                                                    <>
                                                    Manimegalai Vdo
                                                    <video src={mediaBlobUrl} controls autoPlay loop />
                                                    </>
                                                )} */}
                                            </div>
                                            <div className="mt-2 line-card">
                                                <div className="line-blue-videoResume" style={{ backgroundColor: "#0000001F" }}></div>
                                                <div className="icon icon-alignment-card d-flex align-items-center justify-content-center">
                                                    <div className="icon-border-video me-3 flex-center">
                                                        <div className="tick-symbol">&#10003;</div>
                                                    </div>
                                                </div>
                                                <div className="place-button-bottom-video">
                                                    <div className="d-flex align-items-center justify-content-between mx-2">
                                                        <Button sx={{ color: '#0044C6' }} className="button-transparent pointer" onClick={handleVdoRestart} disabled={status === "idle"}>Restart</Button>
                                                        {activeStep === 6 ?
                                                            <Button variant='contained' sx={{ backgroundColor: '#0044C6' }} className="text-right fav-button pointer" onClick={() => { handleSave() }}>Save</Button>
                                                            : <Button variant='contained' sx={{ backgroundColor: '#0044C6' }} className="text-right fav-button pointer" onClick={handleNext}>Continue</Button>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="Increase_ActiveStepArrows d-flex justify-content-between align-items-center">
                                            <div className={`arrow-item-div flex-center ${activeStep === 0 ? 'disabled' : ''}`}
                                                onClick={activeStep === 0 ? null : handlePrev}
                                                style={{ cursor: activeStep === 0 ? 'not-allowed' : 'pointer' }}>
                                                <FaAngleLeft color='#fff' />
                                            </div>
                                            <div className={`arrow-item-div flex-center ${activeStep === steps.length - 1 ? 'disabled' : ''}`}
                                                onClick={activeStep === steps.length - 1 ? null : handleNext}
                                                style={{ cursor: activeStep === steps.length - 1 ? 'not-allowed' : 'pointer' }}>
                                                <FaAngleRight color='#fff' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {openBigScreen &&
                <div className='bg-videoResume-Screen flex-center'>
                    <div className="video-resume-bigScreen">
                        <div className='d-flex align-items-center justify-content-between'>
                            <div className="flex-center mt-3 mb-2 px-2">
                                <img src={record_icon} alt="Recording Symbol" className="max-24px" />
                                <span className="ms-1 recording-font" id="timerDisplay">REC: 00: 00</span>
                                {/* <div className="ms-1 recording-font">REC 00:12:36</div> */}
                            </div>
                            <button className="lightbox-close pointer" onClick={() => { setopenBigScreen(false); }}>&times;</button>
                        </div>
                        <div className='d-flex'>
                            <div className="bigScreen-left-part">
                                <div className="video-screen" style={{ overflow: 'hidden' }}>
                                    {/* <CustomMediaRecorder2 setRecorderStatus={setRecorderStatus} /> */}
                                    <div className="media-recorder-videoResume" >
                                        {stream && (
                                            <video
                                                ref={bigScreenVideoRef}
                                                autoPlay
                                                muted
                                            />
                                        )}
                                        {/* {mediaBlobUrl && <video src={mediaBlobUrl} controls autoPlay loop />} */}
                                        <div className="controls-video-resume d-flex justify-content-center align-items-center gap-4">
                                            {status === "recording" ? (
                                                <>
                                                    {/* Pause button */}
                                                    <button onClick={handleVdoPause}>
                                                        <img className='Video-Resume-LargeScreen-Controls' src={Video_pause} alt="pause_button" />
                                                    </button>
                                                    {/* End recording button */}
                                                    <button onClick={handleVdoEnd}>
                                                        <img className='Video-Resume-LargeScreen-Controls' src={Video_End} alt="end_button" />
                                                    </button>
                                                </>
                                            ) : status === "paused" ? (
                                                <>
                                                    {/* Resume button */}
                                                    <button onClick={handleVdoPlay}>
                                                        <img className='Video-Resume-LargeScreen-Controls' src={Video_play} alt="resume_button" />
                                                    </button>
                                                    {/* End recording button */}
                                                    <button onClick={handleVdoEnd}>
                                                        <img className='Video-Resume-LargeScreen-Controls' src={Video_End} alt="end_button" />
                                                    </button>
                                                </>
                                            ) : (
                                                <>
                                                    {/* Start recording button */}
                                                    <button onClick={handleVdoStart}>
                                                        <img className='Video-Resume-LargeScreen-Controls' src={Video_Start} alt="start_button" />
                                                    </button>
                                                </>
                                            )}
                                            {/* {status === "recording" ? (
                                                <button>
                                                    <img src={AnimateDataGIF} alt="pause_button" />
                                                </button>
                                            ) : (
                                                <button>
                                                    <img src={voice_indicator} alt="voice" />
                                                </button>
                                            )} */}
                                            <button>
                                                <img src={voice_indicator} alt="voice" />
                                            </button>
                                            {(status === 'recording' || status === 'paused') &&
                                                <button onClick={handleVdoRestart}>
                                                    <img className='Video-Resume-LargeScreen-Controls' src={replay} alt="replay_button" />
                                                </button>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="my-3 video-recording-progress flex-center justify-content-start">
                                    <div className="mx-3 resume-progrss-subBox min-widthBigScreen">
                                        <span className="d-block ps-4 my-1">Resume Progress</span>
                                        <div className='p-3 flex-center flex-column gap-1'>
                                            <div>Time left: {Math.floor(remainingTime / 1000)} seconds and Active Step: {activeStep}</div>
                                            <Box sx={{ width: '90%' }} className="resume-progress-first">
                                                <LinearProgressWithLabel value={particularProgress} content={"Particular Section"} />
                                            </Box>
                                            <Box sx={{ width: '90%' }} className="resume-progress-Overalll">
                                                <LinearProgressWithLabel value={progress} content={"Overall Section"} />
                                            </Box>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bigScreen-right-part px-4">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div
                                        className={`arrow-item-div flex-center ${activeStep === 0 ? 'disabled' : ''}`}
                                        onClick={activeStep === 0 ? null : handlePrev}
                                        style={{ cursor: activeStep === 0 ? 'not-allowed' : 'pointer' }}
                                    >
                                        <FaAngleLeft color='#fff' />
                                    </div>
                                    <p className='fw-bold'>{steps[activeStep]}</p>
                                    <div
                                        className={`arrow-item-div flex-center ${activeStep === steps.length - 1 ? 'disabled' : ''}`}
                                        onClick={activeStep === steps.length - 1 ? null : handleNext}
                                        style={{ cursor: activeStep === steps.length - 1 ? 'not-allowed' : 'pointer' }}
                                    >
                                        <FaAngleRight color='#fff' />
                                    </div>
                                </div>

                                <div className="second-box-bigScreen p-4">
                                    <div className="content-for-CurrentTitle">
                                        {getStepContent(activeStep)}
                                    </div>
                                    <div className="mt-2 line-card">
                                        <div className="line-blue-videoResume" style={{ backgroundColor: "#0000001F" }}></div>
                                        <div className="icon icon-alignment-card d-flex align-items-center justify-content-center">
                                            <div className="icon-border-video me-3 flex-center">
                                                <div className="tick-symbol">&#10003;</div>
                                            </div>
                                        </div>
                                        <div className="Continue-Button-BigScreen text-end">
                                            {activeStep === 6 ?
                                                <Button variant='contained' sx={{ backgroundColor: '#0044C6' }} className="text-right fav-button pointer" onClick={() => { handleSave() }}>Save</Button>
                                                : <Button variant='contained' sx={{ backgroundColor: '#0044C6' }} className="text-right fav-button pointer" onClick={handleNext}>Continue</Button>
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            }

            <Modal open={isInstructionsOpen} onClose={handleInstructionModalClose}>
                <Box sx={{
                    position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: "auto", bgcolor: 'white',
                    boxShadow: "0px 4px 4px 0px #00000040", p: 3, borderRadius: 2, minWidth: '50%', maxHeight: "80%", overflowY: "auto"
                }}>
                    <div className="soc-modal-heading mb-3 position-relative">
                        <h5>How to Create your Video Resume</h5>
                        <span className='span-center-align file-attach-icon-container'>
                            <IconButton color="rgb(0, 0, 0, 0.54)" onClick={handleInstructionModalClose}>
                                <CloseRoundedIcon />
                            </IconButton></span>
                    </div>
                    <div className="soc-modal-content">
                        {/* Steps Section */}
                        <div className="video-resume-steps mb-4">
                            <h6>Steps to Create Your Video Resume</h6>
                            <ol className="steps-list">
                                <li>
                                    Select the "Start Recording" button to begin your video resume. You will have a maximum of 2 minutes to record your video resume.
                                </li>
                                <li>
                                    The content for each section (e.g., About Me, Education, Experience, etc.) will be displayed beside the video.
                                </li>
                                <li>
                                    Record your response for each section. Once finished, click "Continue" to move to the next section.
                                </li>
                                <li>
                                    After completing the last section, click the "Save" button to save your video resume. Your video resume will be saved to your local machine.
                                </li>
                                <li>
                                    Once saved, you will be taken back to the profile section page, and your video resume will be available for review.
                                </li>
                            </ol>
                        </div>

                        {/* Instructions Section */}
                        <div className="video-resume-instructions">
                            <h6>Instructions</h6>
                            <ul className="instructions-list">
                                <li>Sit in a quiet place with ample lighting to ensure good video and audio quality.</li>
                                <li>Make sure you're dressed appropriately for a professional video.</li>
                                <li>Ensure the background is clutter-free and non-distracting.</li>
                                <li>Speak clearly and confidently, maintaining eye contact with the camera.</li>
                                <li>Take your time and don't rush through your responses.</li>
                                <li>The maximum length of the video is 2 minutes.</li>
                                {/* <li>You can only have 1 video resume at a time.</li> */}
                            </ul>
                        </div>
                    </div>
                </Box>
            </Modal>

            <Modal open={timeUpModalOpen} onClose={handleTimeUpModalClose}>
                <Box sx={{
                    position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: "auto", bgcolor: 'white',
                    boxShadow: "0px 4px 4px 0px #00000040", borderRadius: 2, minWidth: '50%', maxHeight: "80%", overflowY: "auto"
                }}>
                    <>
                        <div className="p-4">
                            <div className="soc-modal-heading position-relative">
                                <div className="profile-modal-heading1">Total Time is Up!</div>
                            </div>
                        </div>
                        <Divider sx={{ backgroundColor: "#DDE0E6", height: "1px", opacity: 1 }} />
                        <div className="p-4 pt-3">
                            <span className='heading-fav-content text-left'>The total time for recording your video resume (2 minutes) has lapsed. Would you like to save your recorded resume, or attempt creating a new one?</span>
                            <div className='d-flex justify-content-end mt-4 gap-3'>
                                <Button variant="outlined" sx={{ color: "#0044C6" }} onClick={() => { handleTimeUpModalClose() }}>Retake</Button>
                                <Button variant="contained" sx={{ backgroundColor: "#0044C6" }} onClick={() => { handleSave(); handleTimeUpModalClose() }}>Save</Button>
                            </div>
                        </div>
                    </>
                </Box>
            </Modal>

            <ToastContainer position="bottom-left" toastClassName="email-toast-success" />
        </>
    );
};

function LinearProgressWithLabel(props) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
            <Box sx={{ width: '100%' }}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            {/* <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}> */}
            <Box className="VideoResume-progressline" sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography variant="body2" color="text.secondary">{props.content}</Typography>
                <Typography variant="body2" color="text.secondary">{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}

LinearProgressWithLabel.propTypes = {
    value: PropTypes.number.isRequired,
};


export default VideoResume;

// const CustomMediaRecorder2 = ({ setRecorderStatus }) => {
//     const {
//         status,
//         startRecording,
//         stopRecording,
//         pauseRecording,
//         resumeRecording,
//         mediaBlobUrl,
//         previewStream
//     } = useReactMediaRecorder({ video: true });

//     setRecorderStatus(status);
//     return (
//         <div className="media-recorder-videoResume" >
//             {previewStream && (
//                 <video
//                     ref={(video) => {
//                         if (video) {
//                             video.srcObject = previewStream;
//                         }
//                     }}
//                     autoPlay
//                     muted
//                 />
//             )}
//             {/* {mediaBlobUrl && <video src={mediaBlobUrl} controls autoPlay loop />} */}
//             <div className="controls-video-resume d-flex justify-content-center align-items-center gap-4">
//                 {status === "recording" ? (
//                     <button onClick={pauseRecording}>
//                         <img src={Video_pause} alt="pause_button" />
//                     </button>
//                 ) : (
//                     <button onClick={resumeRecording}>
//                         <img src={Video_play } alt="resume_button" />
//                     </button>
//                 )}
//                 {status === "recording" ? (
//                     <button onClick={stopRecording}>
//                         <img src={Video_End} alt="pause_button" />
//                     </button>
//                 ) : (
//                     <button onClick={startRecording}>
//                         <img src={Video_Start} alt="resume_button" />
//                     </button>
//                 )}
//                 <button>
//                     <img src={voice_indicator} alt="voice" />
//                 </button>
//                 <button>
//                     <img src={replay} alt="replay_button" />
//                 </button>
//             </div>
//         </div>
//     );
// };
